<template>
  <BaseListHeader> Name </BaseListHeader>
</template>

<script>
export default {
  name: 'ListHeader',
};
</script>
